import RaceMixins from '../../../../../components/_mixins/races'
import config from '../../../../../lib/config'
import {alert, getQS} from '../../../../../lib/utils'
const qs = getQS() || {}
const noHold = !!qs.nohold

export default {
  name: 'timeslot',
  mixins: [RaceMixins],
  props: {
    time: { default: null },
    disabled: { default: false },
  },
  data() {
    return {
      slotUnit: .5,
      item: null
    }
  },
  created() {
    this.item = this.retrievedTimeslot(this.time)
  },
  computed: {
    consecutiveSlotsToGroup() {
      let count = 1
      const hours = this.input('numberOfHours') || 1
      if (this.isSlotGroupingEnabled) {
        count = hours / this.slotUnit
      }
      return count
    },
    disableSelection() {
      return this.disabled
    },
    selected: {
      get() {
        return this.item.selected
      },
      set(value) {
        const item = this.item
        this.setRetrievedTimeslotData({time: item.time, key: 'selected', value})
      }
    }
  },
  methods: {
    visible() {
      // console.log({time: this.time, visible: this.item.visible})
      return this.item.visible
    },
    selectable() {
      // console.log({time: this.time, selectable: this.item.selectable})
      return this.item.selectable
    },
    getChildren(item) {
      const count = this.consecutiveSlotsToGroup
      const children = []
      let thisItem = item
      for (let i = 1; i < count; i++) {
        let nextTime = thisItem.nextTime
        if (nextTime) {
          let nextItem = this.retrievedTimeslot(nextTime)
          children.push(nextTime)
          thisItem = nextItem
        }
      }
      return children
    },
    isAnyProcessing() {
      return _.some(this.selectedSlots || {}, ({processing = false}) => processing)
    },
    async selection() {
      if (this.item.processing) {
        alert('This slot is being processed.')
        return false
      }
      if (!this.selected && this.isAnyProcessing()) {
        alert('Slots are being processed! Wait until processing is over.')
        return false
      }
      if (!this.selected && !this.selectable()) {
        alert('This slot can not be selected')
        return false
      }
      if (!this.visible || this.disableSelection) {
        return false
      }

      const thisItem = this.item
      const item = thisItem.parent ? this.retrievedTimeslot(thisItem.parent) : this.item
      const time = item.time
      const oldSelected = item.selected
      let selected = !oldSelected
      const racers = this.totalPlayers

      // this.selected = !selected
      let children = oldSelected ? _.cloneDeep(item.children) : this.getChildren(item)

      let holds = null
      if (!selected) {
        await this.unholdSlot(item, children)
      } else {
        this.unholdSelectedSlots()
        const now = (new Date()).valueOf()
        selected = now
        this.selectTimeslot({time, selected: (new Date()).valueOf(), racers, children})

        holds = await this.holdSlot(item, racers, children)
        if (!holds) {
          selected = false
        }
      }
      this.updateTimeslotSelection({time, selected, racers, children, holds})
    },
    unholdSelectedSlots() {
      const selected = this.selectedAllTimeslots
      if (!_.isEmpty(selected)) {
        const item = _.find(selected, o => !o.parent)
        const children = _.cloneDeep(item.children || [])
        this.unholdSlot(item, children, true)
      }
    }
  }
}
